import { columnDef_header_Z5FD1F5D2, columnDef_id_Z721C83C5, columnDef_accessorFn_77A7E8C8, columnDef_cell_Z1DDB00E5, columnDef_accessorKey_Z721C83C5, columnDef_columns_Z2906D979, columnDef_footer_Z5FD1F5D2, columnDef_header_Z721C83C5 } from "../../Feliz.TanStack.Table/ColumnDef.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library.3.7.1/List.js";
import { createElement } from "react";
import { toString, FSharpRef, Union, Record } from "../fable_modules/fable-library.3.7.1/Types.js";
import { option_type, class_type, union_type, record_type, string_type, int32_type } from "../fable_modules/fable-library.3.7.1/Reflection.js";
import { Types_Person, MakeData_make, Types_Person$reflection } from "../MakeData.fs.js";
import { Table_getRowModel_Z4395D14A, Table_getVisibleCells_773C3262, Table_getContext_Z78EF7AD2, Html_flexRender_Z6DEE00B4, Table_getHeaderGroups_Z4395D14A, Table_getPreFilteredRowModel_Z4395D14A, Table_getContext_315F98D7, Html_flexRender_39247646, Table_init_Z5C3B000E } from "../../Feliz.TanStack.Table/Table.fs.js";
import { tableProps_paginationRowModel, tableProps_filteredRowModel, tableProps_columns_Z2906D979 } from "../../Feliz.TanStack.Table/TableProps.fs.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { tryParse } from "../fable_modules/fable-library.3.7.1/Int32.js";
import { Table_getState_Z4395D14A, Table_setData } from "../../Feliz.TanStack.Table/TableState.fs.js";
import { head, mapIndexed } from "../fable_modules/fable-library.3.7.1/Array.js";
import { Column_getFilterValue_Z2685F962, Column_getCanFilter_Z2685F962, Column_setFilterValue } from "../../Feliz.TanStack.Table/Filter.fs.js";
import { some, value as value_95 } from "../fable_modules/fable-library.3.7.1/Option.js";
import { Table_hasNextPage_Z4395D14A, Table_hasPreviousPage_Z4395D14A, Table_setPageSize, Table_getPageCount_Z4395D14A, Table_setPageIndex, Table_nextPage_Z4395D14A, Table_previousPage_Z4395D14A } from "../../Feliz.TanStack.Table/Pagination.fs.js";
import { FSharpMap__get_Item, ofList } from "../fable_modules/fable-library.3.7.1/Map.js";
import { append, singleton as singleton_1, map, delay, toList } from "../fable_modules/fable-library.3.7.1/Seq.js";
import { round, createObj, int32ToString } from "../fable_modules/fable-library.3.7.1/Util.js";
import { rangeDouble } from "../fable_modules/fable-library.3.7.1/Range.js";
import { join } from "../fable_modules/fable-library.3.7.1/String.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.67.0/Interop.fs.js";
import { Row_getValue } from "../../Feliz.TanStack.Table/Row.fs.js";
import { Table_getCenterTotalSize_Z4395D14A } from "../../Feliz.TanStack.Table/Sizing.fs.js";
import { useFeliz_React__React_useElmish_Static_B42E862 } from "../fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";

export const defaultColumns = ofArray([ofArray([columnDef_header_Z721C83C5("Name"), columnDef_footer_Z5FD1F5D2((props) => props.column.id), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Firstname"), columnDef_cell_Z1DDB00E5((info) => info.getValue()), columnDef_footer_Z5FD1F5D2((props_1) => props_1.column.id)]), ofArray([columnDef_accessorFn_77A7E8C8((p) => p.Lastname), columnDef_id_Z721C83C5("Lastname"), columnDef_cell_Z1DDB00E5((info_1) => info_1.getValue()), columnDef_header_Z5FD1F5D2((_arg1) => createElement("span", {
    children: "Last Name",
})), columnDef_footer_Z5FD1F5D2((props_3) => props_3.column.id)])]))]), ofArray([columnDef_header_Z721C83C5("Info"), columnDef_footer_Z5FD1F5D2((props_4) => props_4.column.id), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Age"), columnDef_header_Z5FD1F5D2((_arg2) => "Age"), columnDef_footer_Z5FD1F5D2((props_5) => props_5.column.id)]), ofArray([columnDef_header_Z721C83C5("More Info"), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Visits"), columnDef_header_Z5FD1F5D2((_arg3) => createElement("span", {
    children: "Visits",
})), columnDef_footer_Z5FD1F5D2((props_7) => props_7.column.id)]), ofArray([columnDef_accessorKey_Z721C83C5("Status"), columnDef_header_Z721C83C5("Status"), columnDef_footer_Z5FD1F5D2((props_8) => props_8.column.id)]), ofArray([columnDef_accessorKey_Z721C83C5("Progress"), columnDef_header_Z721C83C5("Profile Progress"), columnDef_footer_Z5FD1F5D2((props_9) => props_9.column.id)])]))])]))])]);

export class EditingData extends Record {
    constructor(RowIndex, ColumnId, Value) {
        super();
        this.RowIndex = (RowIndex | 0);
        this.ColumnId = ColumnId;
        this.Value = Value;
    }
}

export function EditingData$reflection() {
    return record_type("Examples.EditableData.EditingData", [], EditingData, () => [["RowIndex", int32_type], ["ColumnId", string_type], ["Value", string_type]]);
}

export class PropertyChange extends Record {
    constructor(EditingData, NewValue) {
        super();
        this.EditingData = EditingData;
        this.NewValue = NewValue;
    }
}

export function PropertyChange$reflection() {
    return record_type("Examples.EditableData.PropertyChange", [], PropertyChange, () => [["EditingData", EditingData$reflection()], ["NewValue", string_type]]);
}

export class FilterChangeType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Min", "Max", "Search"];
    }
}

export function FilterChangeType$reflection() {
    return union_type("Examples.EditableData.FilterChangeType", [], FilterChangeType, () => [[], [], []]);
}

export class FilterChange extends Record {
    constructor(Column, Type, Value) {
        super();
        this.Column = Column;
        this.Type = Type;
        this.Value = Value;
    }
}

export function FilterChange$reflection() {
    return record_type("Examples.EditableData.FilterChange", [], FilterChange, () => [["Column", class_type("Feliz.TanStack.Table.Types.Column`1", [Types_Person$reflection()])], ["Type", FilterChangeType$reflection()], ["Value", string_type]]);
}

export class PaginateChange extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["First", "Previous", "Next", "Last", "Index"];
    }
}

export function PaginateChange$reflection() {
    return union_type("Examples.EditableData.PaginateChange", [], PaginateChange, () => [[], [], [], [], [["Item", int32_type]]]);
}

export class State extends Record {
    constructor(Table, EditingData) {
        super();
        this.Table = Table;
        this.EditingData = EditingData;
    }
}

export function State$reflection() {
    return record_type("Examples.EditableData.State", [], State, () => [["Table", class_type("Feliz.TanStack.Table.Types.Table`1", [Types_Person$reflection()])], ["EditingData", option_type(EditingData$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CellClicked", "PropertyChanged", "FinishedEditing", "FilterChanged", "Paginate", "PageSizeChange"];
    }
}

export function Msg$reflection() {
    return union_type("Examples.EditableData.Msg", [], Msg, () => [[["rowIndex", int32_type], ["columnId", string_type]], [["Item", PropertyChange$reflection()]], [], [["Item", FilterChange$reflection()]], [["Item", PaginateChange$reflection()]], [["Item", int32_type]]]);
}

export function init() {
    return [new State(Table_init_Z5C3B000E(ofArray([["data", MakeData_make(1000)], tableProps_columns_Z2906D979(defaultColumns), tableProps_filteredRowModel(), tableProps_paginationRowModel(), ["autoResetPageIndex", true]])), void 0), Cmd_none()];
}

export function update(msg, state) {
    let inputRecord, outArg_1;
    switch (msg.tag) {
        case 1: {
            const propertyChange = msg.fields[0];
            const editingPerson = state.Table.Data[propertyChange.EditingData.RowIndex];
            const newValue = propertyChange.NewValue;
            let patternInput;
            const matchValue = propertyChange.EditingData.ColumnId;
            if (matchValue === "Firstname") {
                patternInput = [new Types_Person(newValue, editingPerson.Lastname, editingPerson.Age, editingPerson.Visits, editingPerson.Status, editingPerson.Progress), newValue];
            }
            else if (matchValue === "Lastname") {
                patternInput = [new Types_Person(editingPerson.Firstname, newValue, editingPerson.Age, editingPerson.Visits, editingPerson.Status, editingPerson.Progress), newValue];
            }
            else if (matchValue === "Status") {
                patternInput = [new Types_Person(editingPerson.Firstname, editingPerson.Lastname, editingPerson.Age, editingPerson.Visits, newValue, editingPerson.Progress), newValue];
            }
            else {
                const prop_6 = matchValue;
                let matchValue_1;
                let outArg = 0;
                matchValue_1 = [tryParse(newValue, 511, false, 32, new FSharpRef(() => outArg, (v) => {
                    outArg = (v | 0);
                })), outArg];
                let pattern_matching_result;
                if (matchValue_1[0]) {
                    if (prop_6 === "Age") {
                        pattern_matching_result = 0;
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        patternInput = [new Types_Person(editingPerson.Firstname, editingPerson.Lastname, matchValue_1[1], editingPerson.Visits, editingPerson.Status, editingPerson.Progress), newValue];
                        break;
                    }
                    case 1: {
                        let pattern_matching_result_1;
                        if (matchValue_1[0]) {
                            if (prop_6 === "Visits") {
                                pattern_matching_result_1 = 0;
                            }
                            else {
                                pattern_matching_result_1 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                        switch (pattern_matching_result_1) {
                            case 0: {
                                patternInput = [new Types_Person(editingPerson.Firstname, editingPerson.Lastname, editingPerson.Age, matchValue_1[1], editingPerson.Status, editingPerson.Progress), newValue];
                                break;
                            }
                            case 1: {
                                let pattern_matching_result_2;
                                if (matchValue_1[0]) {
                                    if (prop_6 === "Progress") {
                                        pattern_matching_result_2 = 0;
                                    }
                                    else {
                                        pattern_matching_result_2 = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result_2 = 1;
                                }
                                switch (pattern_matching_result_2) {
                                    case 0: {
                                        patternInput = [new Types_Person(editingPerson.Firstname, editingPerson.Lastname, editingPerson.Age, editingPerson.Visits, editingPerson.Status, matchValue_1[1]), newValue];
                                        break;
                                    }
                                    case 1: {
                                        patternInput = [editingPerson, propertyChange.EditingData.Value];
                                        break;
                                    }
                                }
                                break;
                            }
                        }
                        break;
                    }
                }
            }
            return [new State(Table_setData(mapIndexed((i, d) => {
                if (i === propertyChange.EditingData.RowIndex) {
                    return patternInput[0];
                }
                else {
                    return d;
                }
            }, state.Table.Data), state.Table), (inputRecord = propertyChange.EditingData, new EditingData(inputRecord.RowIndex, inputRecord.ColumnId, patternInput[1]))), Cmd_none()];
        }
        case 2: {
            return [new State(state.Table, void 0), Cmd_none()];
        }
        case 3: {
            const change = msg.fields[0];
            const matchValue_2 = change.Type;
            if (matchValue_2.tag === 2) {
                Column_setFilterValue((_arg1) => change.Value, change.Column);
            }
            else {
                const matchValue_3 = [(outArg_1 = 0, [tryParse(change.Value, 511, false, 32, new FSharpRef(() => outArg_1, (v_1) => {
                    outArg_1 = (v_1 | 0);
                })), outArg_1]), matchValue_2];
                let pattern_matching_result_3;
                if (matchValue_3[0][0]) {
                    if (matchValue_3[1].tag === 1) {
                        pattern_matching_result_3 = 0;
                    }
                    else if (matchValue_3[1].tag === 0) {
                        pattern_matching_result_3 = 1;
                    }
                    else {
                        pattern_matching_result_3 = 2;
                    }
                }
                else {
                    pattern_matching_result_3 = 2;
                }
                switch (pattern_matching_result_3) {
                    case 0: {
                        const n_6 = matchValue_3[0][1] | 0;
                        Column_setFilterValue((prevOpt) => {
                            let min;
                            return (prevOpt != null) ? ((prevOpt[0] != null) ? ((min = value_95(prevOpt[0]), [some(min), n_6])) : [void 0, n_6]) : [void 0, n_6];
                        }, change.Column);
                        break;
                    }
                    case 1: {
                        const n_7 = matchValue_3[0][1] | 0;
                        Column_setFilterValue((prevOpt_1) => {
                            let max;
                            return (prevOpt_1 != null) ? ((prevOpt_1[1] != null) ? ((max = value_95(prevOpt_1[1]), [n_7, some(max)])) : [n_7, void 0]) : [n_7, void 0];
                        }, change.Column);
                        break;
                    }
                }
            }
            return [new State(state.Table, state.EditingData), Cmd_none()];
        }
        case 4: {
            const paginateChange = msg.fields[0];
            return [new State((paginateChange.tag === 1) ? Table_previousPage_Z4395D14A(state.Table) : ((paginateChange.tag === 2) ? Table_nextPage_Z4395D14A(state.Table) : ((paginateChange.tag === 3) ? Table_setPageIndex(Table_getPageCount_Z4395D14A(state.Table) - 1, state.Table) : ((paginateChange.tag === 4) ? Table_setPageIndex(paginateChange.fields[0], state.Table) : Table_setPageIndex(0, state.Table)))), state.EditingData), Cmd_none()];
        }
        case 5: {
            return [new State(Table_setPageSize(msg.fields[0], state.Table), state.EditingData), Cmd_none()];
        }
        default: {
            return [new State(state.Table, new EditingData(msg.fields[0], msg.fields[1], "")), Cmd_none()];
        }
    }
}

export function view(state, dispatch) {
    let elems_3, children, properties_8, elems_2, elems_1, elems_9, properties_19;
    let paginationControls;
    const selectOptions = ofList(toList(delay(() => map((i) => [int32ToString(i), [`Show ${i}`, () => {
        dispatch(new Msg(5, i));
    }]], rangeDouble(10, 10, 50)))));
    const pageControl = (text, isDisabled, onClick) => createElement("button", {
        className: join(" ", ["button"]),
        children: text,
        disabled: isDisabled,
        onClick: onClick,
    });
    paginationControls = createElement("div", createObj(ofArray([["className", join(" ", ["is-inline-block"])], (elems_3 = [pageControl("\u003c\u003c", !Table_hasPreviousPage_Z4395D14A(state.Table), (_arg2) => {
        dispatch(new Msg(4, new PaginateChange(0)));
    }), pageControl("\u003c", !Table_hasPreviousPage_Z4395D14A(state.Table), (_arg3) => {
        dispatch(new Msg(4, new PaginateChange(1)));
    }), pageControl("\u003e", !Table_hasNextPage_Z4395D14A(state.Table), (_arg4) => {
        dispatch(new Msg(4, new PaginateChange(2)));
    }), pageControl("\u003e\u003e", !Table_hasNextPage_Z4395D14A(state.Table), (_arg5) => {
        dispatch(new Msg(4, new PaginateChange(3)));
    }), (children = ofArray(["Page ", Table_getState_Z4395D14A(state.Table).pagination.pageIndex + 1, " of ", Table_getPageCount_Z4395D14A(state.Table), " | Go to page:"]), createElement("p", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    })), createElement("input", createObj(ofArray([["className", join(" ", ["input"])], ["type", "number"], (properties_8 = singleton(["width", 4 + "rem"]), ["style", createObj(properties_8)]), ["defaultValue", Table_getState_Z4395D14A(state.Table).pagination.pageIndex + 1], ["onChange", (ev_3) => {
        const value_54 = ev_3.target.valueAsNumber;
        if ((!(value_54 == null)) && (!Number.isNaN(value_54))) {
            dispatch(new Msg(4, new PaginateChange(4, round(value_54))));
        }
    }]]))), createElement("div", createObj(ofArray([["className", join(" ", ["select"])], (elems_2 = [createElement("select", createObj(ofArray([["onChange", (event) => {
        FSharpMap__get_Item(selectOptions, event.target.value)[1]();
    }], ["value", `${Table_getState_Z4395D14A(state.Table).pagination.pageSize}`], (elems_1 = toList(delay(() => map((option) => createElement("option", {
        key: option[0],
        value: option[0],
        children: option[1][0],
    }), selectOptions))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
    let table_1;
    let thead;
    const children_4 = toList(delay(() => map((headerGroup) => {
        let elems_5;
        return createElement("tr", createObj(ofArray([["key", headerGroup.id], (elems_5 = toList(delay(() => map((header) => {
            let elems_4;
            return createElement("th", createObj(ofArray([["key", header.id], ["colSpan", header.colSpan], (elems_4 = toList(delay(() => {
                let children_2;
                return header.isPlaceholder ? singleton_1(null) : singleton_1((children_2 = toList(delay(() => append(singleton_1(Html_flexRender_39247646(state, dispatch, header.column.columnDef.header, Table_getContext_315F98D7(header))), delay(() => {
                    let column, firstValue, columnFilterValue, elems;
                    return Column_getCanFilter_Z2685F962(header.column) ? singleton_1((column = header.column, (firstValue = Row_getValue(column, head(Table_getPreFilteredRowModel_Z4395D14A(state.Table).flatRows)), (columnFilterValue = Column_getFilterValue_Z2685F962(column), createElement("div", createObj(ofArray([["className", join(" ", ["is-flex"])], (elems = toList(delay(() => {
                        let properties, v, properties_4;
                        return (typeof firstValue === 'number') ? append(singleton_1(createElement("input", createObj(ofArray([(properties = singleton(["width", 6 + "rem"]), ["style", createObj(properties)]), ["placeholder", "Min..."], ["value", (columnFilterValue != null) ? ((columnFilterValue[0] != null) ? ((v = columnFilterValue[0], v[0])) : "") : ""], ["onChange", (ev) => {
                            dispatch(new Msg(3, new FilterChange(column, new FilterChangeType(0), ev.target.value)));
                        }]])))), delay(() => {
                            let properties_2, v_1;
                            return singleton_1(createElement("input", createObj(ofArray([(properties_2 = singleton(["width", 6 + "rem"]), ["style", createObj(properties_2)]), ["placeholder", "Max..."], ["value", (columnFilterValue != null) ? ((columnFilterValue[1] != null) ? ((v_1 = columnFilterValue[1], v_1[1])) : "") : ""], ["onChange", (ev_1) => {
                                dispatch(new Msg(3, new FilterChange(column, new FilterChangeType(1), ev_1.target.value)));
                            }]]))));
                        })) : singleton_1(createElement("input", createObj(ofArray([(properties_4 = singleton(["width", 8 + "rem"]), ["style", createObj(properties_4)]), ["placeholder", "Search..."], ["value", (columnFilterValue == null) ? "" : toString(columnFilterValue)], ["onChange", (ev_2) => {
                            dispatch(new Msg(3, new FilterChange(column, new FilterChangeType(2), ev_2.target.value)));
                        }]]))));
                    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))))))) : singleton_1(null);
                })))), createElement("div", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_2)),
                })));
            })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
        }, headerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])));
    }, Table_getHeaderGroups_Z4395D14A(state.Table))));
    thead = createElement("thead", {
        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
    });
    let tbody;
    const children_6 = toList(delay(() => map((row) => {
        let elems_7;
        return createElement("tr", createObj(ofArray([["key", row.id], (elems_7 = toList(delay(() => map((cell) => {
            let elems_6;
            return createElement("td", createObj(ofArray([["onClick", (_arg6) => {
                dispatch(new Msg(0, cell.row.index, cell.column.id));
            }], (elems_6 = toList(delay(() => {
                let editingData;
                const matchValue = state.EditingData;
                let pattern_matching_result, editingData_1;
                if (matchValue != null) {
                    if ((editingData = matchValue, (cell.column.id === editingData.ColumnId) && (cell.row.index === editingData.RowIndex))) {
                        pattern_matching_result = 0;
                        editingData_1 = matchValue;
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        return singleton_1(createElement("input", {
                            onChange: (ev_4) => {
                                dispatch(new Msg(1, new PropertyChange(editingData_1, ev_4.target.value)));
                            },
                            onBlur: (_arg7) => {
                                dispatch(new Msg(2));
                            },
                            autoFocus: true,
                            value: editingData_1.Value,
                        }));
                    }
                    case 1: {
                        return singleton_1(Html_flexRender_Z6DEE00B4(cell.column.columnDef.cell, Table_getContext_Z78EF7AD2(cell)));
                    }
                }
            })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])));
        }, Table_getVisibleCells_773C3262(row)))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])));
    }, Table_getRowModel_Z4395D14A(state.Table).rows)));
    tbody = createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_6)),
    });
    table_1 = createElement("div", createObj(ofArray([["className", join(" ", ["p-2"])], (elems_9 = [createElement("table", createObj(ofArray([(properties_19 = singleton(["width", Table_getCenterTotalSize_Z4395D14A(state.Table)]), ["style", createObj(properties_19)]), ["children", Interop_reactApi.Children.toArray([thead, tbody])]]))), paginationControls], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])])));
    return createElement("div", {
        children: Interop_reactApi.Children.toArray([table_1]),
    });
}

export function Component() {
    const patternInput = useFeliz_React__React_useElmish_Static_B42E862(init, update);
    return view(patternInput[0], patternInput[1]);
}

//# sourceMappingURL=EditableData.fs.js.map
